<template>
 <div :class="windowClass">
    <v-row class="secondary" no-gutters>
        <v-col md="3" class="pa-1">
           <va-stat-card 
              color="secondary"
              icon="mdi-cart"
              label="Today's Sales"
              :data="$money($IsNum(TODAYS_SALES))"
              sup="PHP"
            />
        </v-col>
        <v-col md="3" class="pa-1">
            <va-stat-card 
              color="secondary"
              icon="mdi-calendar"
              label="THIS MONTH GROSS"
              :data="$money($IsNum(THIS_MONTH_SALES.gross_sales))"
              sup="PHP"
            />
        </v-col>
        <v-col md="3" class="pa-1">
             <va-stat-card 
              color="secondary"
              icon="mdi-calendar-check-outline"
              label="MONTHLY COLLECTION"
              :data="$money($IsNum(CREDITS.collection))"
              sup="PHP"
            />
        </v-col>
        <v-col md="3" class="pa-1">
            <va-stat-card 
              color="secondary"
              icon="mdi-credit-card-plus-outline"
              label="TOTAL COLLECTIBLES"
             :data="$money($IsNum(CREDITS.credit_amount))"
              sup="PHP"
            />
        </v-col>
    </v-row>
     <chart-gross :rawdata="MONTHDAILYSALES"/>
     <v-row class="secondary" no-gutters style="height: 80px;"></v-row>
    <v-row no-gutters style="margin-top: -50px;">
        <v-col md="6" class="pa-2">
            <v-card>
                <v-card-title class="subtitle-2"><span style="border-bottom: 1px solid #F96332; color: #989898">TODAY'S LATEST TRANSACTIONS <v-icon right small color="primary" @click="$router.push('/transactions').catch(err => {})">mdi-open-in-new</v-icon> </span></v-card-title>
                <v-card-text>
                      <v-data-table
                      :headers="headers"
                      dense
                      class="va-table"
                      :items="TODAYS_TRANSACTIONS"
                      hide-default-header
                    >
                      <template v-slot:body="{ items }">
                        <tbody>
                          <tr v-for="(item,index) in items" :key="index">
                           <td>({{ item.sequence }}) {{ item.supplier_name }}</td>
                            <td>{{ item.customer_name }} <br /><small>{{ item.name }}</small></td>
                            <td># of Kilo: {{ item.kilos }} <br />Price: {{ item.price }}</td>
                            <td><span style="color: #888">{{ item.date | moment("hh:mm:ss a") }}</span></td>
                          </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-col>

         <v-col md="6" class="pa-2">
            <v-card>
                <v-card-title class="subtitle-2"><span style="border-bottom: 1px solid #F96332; color: #989898">TODAY'S SUPPLIES <v-icon right small color="primary" @click="$router.push('/kinds').catch(err => {})">mdi-open-in-new</v-icon></span></v-card-title>
                <v-card-text>
                      <v-data-table
                       class="va-table"
                       dense
                      :headers="headers2"
                      :items-per-page="15"
                      :items="TODAYS_SUPPLIES"
                      hide-default-header
                    >
                     <template v-slot:body="{ items }">
                        <tbody>
                          <tr v-for="(item,index) in items" :key="index">
                           <td>{{ item.name }}</td>
                           <td>{{ item.fishcar }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                <v-card-actions>
                    <span><v-icon color="info" left>mdi-truck</v-icon> FISHCARS : {{FISHCAR}}</span>
                    <span class="ml-10"><v-icon color="success" left>mdi-format-list-text</v-icon> KINDS : {{KINDS}}</span>
                </v-card-actions>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
  </div>
</template>
<script>

import {
  mapMutations
} from 'vuex'
import { API_MIXINS } from '@/mixins/api_mixins.js'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
      headers: [
          {
            text: 'FISHCAR',
            align: 'left',
            value: 'name',
          },
          { text: 'COSTUMER', value: 'customer' },
          { text: 'ITEM', value: 'item' },
          { text: 'TIMESTAMP)', value: 'time' }
        ],
        headers2: [
          {
            text: 'FISHCAR',
            align: 'left',
            value: 'name',
          },
           { text: 'Supplier',
            value: 'fishcar'
           },
        ]
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.loadData()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      TODAYS_TRANSACTIONS() {
          return this.$store.state.todays_transactions
      },
      TODAYS_SALES() {
        var sales = 0
        for (const item of this.TODAYS_TRANSACTIONS) {
             sales += this.$IsNum(item.price) * this.$IsNum(item.kilos)
        }
        return sales
      },
      THIS_MONTH_SALES() {
         return this.$store.state.month_sales
      },
      CREDITS(){
         return this.$store.state.credits
      },
      MONTHDAILYSALES() {
        return this.$store.state.month_daily_sales
      },
      TODAYS_SUPPLIES() {
        return this.$store.state.supplies
      },
      FISHCAR(){
         var groupBy = this.$groupBy('fishcar')
        var fishcar = groupBy(this.$store.state.supplies)
          return Object.keys(fishcar).length
      },
      KINDS(){
         var groupBy = this.$groupBy('name')
          var kinds = groupBy(this.$store.state.supplies)
          return Object.keys(kinds).length
      }

    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      loadData(){
        this.GET_TRANSACTIONS({param1: this.$moment().format('YYYY-MM-DD')})
        this.GET_MONTHSALES()
        this.GET_CREDITS()
        this.GET_MONTHDAILYSALES()
        this.GET_SUPPLIES(this.$moment().format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD'))
      }
    }
  }
</script>